import {
  BOOKS_BOOK_CITATION_SET_DATA,
  BOOKS_BOOK_CITATION_RESET_DATA,
} from 'rebook/apps/books/constants';


const initialState = {
  citation: null,
};

export default function bookCitation(state = initialState, action) {
  switch (action.type) {
    case BOOKS_BOOK_CITATION_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case BOOKS_BOOK_CITATION_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
